import { styled } from "styled-components";

export const LinkLabel = styled.p`
  color: ${({ theme }) => theme.colors.default[900]};
  line-height: 20px;
  font-weight: 600;
  font-size: 16px;
  transition: color 0.2s ease-out;
`;

export const LinkDescription = styled.p`
  color: ${({ theme }) => theme.colors.default[600]};
  font-size: 14px;
  font-weight: 550;
  line-height: 150%;
  transition: color 0.2s ease-out;
`;

export const LinkContainer = styled.div`
  cursor: pointer;
  padding: 0 12px;
  transition: color 0.2s ease-out;
  display: flex;
  flex-direction: column;
  gap: 4px;
  flex-shrink: 0;

  &:hover {
    ${LinkLabel}, ${LinkDescription} {
      color: ${({ theme }) => theme.colors.default[400]};
    }
  }

  ${({ theme }) => theme.breakpoints.md.query} {
    padding: 0 24px;
  }
`;
